import { InjectAuthParamType } from 'new/components/settings/VendorBuilder/types';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { useEffect } from 'react';

export default function useAuthParamsInjector(
  fields: InjectAuthParamType[],
  authTemplateIndex: number,
) {
  const { updateVendor } = useVendorBuilder();

  useEffect(() => {
    updateVendor((newVendor) => {
      const template = newVendor.auth_templates[authTemplateIndex];
      const mapParams = template.params.reduce((map, param) => {
        map[param.name] = true;
        return map;
      }, {});
      fields.forEach((field) => {
        if (field.configName) {
          template.config[field.configName] = `\${${field.param.name}}`;
        }
        if (!mapParams[field.param.name]) {
          template.params.push(field.param);
        }
      });
    });

    return () => {
      updateVendor((newVendor) => {
        fields.forEach((field) => {
          const template = newVendor.auth_templates[authTemplateIndex];
          const indexToRemove = template?.params?.findIndex?.((param) => param === field.param);
          if (field.configName) {
            delete template?.config?.[field.configName];
          }
          if (indexToRemove >= 0) {
            template.params.splice(indexToRemove, 1);
          }
        });
      });
    };
  }, [fields]);
}
